/**
 * The Outer Chart renders headlines, footnotes, and credits.
 */
import spacing from './spacing';
import * as headlines from './headlines';
import * as notes from './notes';
import * as annotations from './annotations';
import * as element from '../util/element';

const MARGIN = 12;

export function preRender(options) {
  let data = {
    exporting: {
      enabled: false,
    },
    chart: {
      renderTo: options.el.querySelector('.dj-chart-container'),
      width: options.width,
      height: options.height,
      reflow: false,
      backgroundColor: 'transparent',
      backgroundColor: options.styles.color.background
    },
    title: { text: null },
    subtitle: { text: null },
    credits: { enabled: false },
  };
  if (options.size.indexOf('thumb') !== 0) {
    data.chart.spacing = spacing(options);
    data = headlines.preRender(data, options);
    data = notes.preRender(data, options);
    data = annotations.preRender(data, options);
  }
  return data;
}


export function postRender(highchart, options) {
  if (options.size.indexOf('thumb') === 0) {
    return {
      innerEl: createInnerEl(highchart, options),
      x: 0,
      y: 0,
      width: options.width,
      height: options.height,
      info: null,
    };
  } else {
    if (__WSJ__) {
      if (options.size === 'print-wsj') {
        highchart.renderer.rect(0, 3.2, options.width, 0.5, 0)
          .attr({
            'fill': '#000',
          })
          .add();
        // let y = 0;
        // while (y < options.height) {
        //   highchart.renderer.rect(0, y, options.width, 0.5, 0)
        //     .attr({
        //       'fill': 'rgba(255, 0, 0, 0.25)',
        //     })
        //     .add();
        //   y += 9.6;
        // }
      }
    }
    // we only want to call annotations.postRender() for charts that are large enough for annotations
    const isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' ||
    options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
    const info = {
      headlines: headlines.postRender(highchart, options),
      notes: notes.postRender(highchart, options),
      annotations: isSmallMW ? 'small' : annotations.postRender(highchart, options)
    }

    let margin = (info.headlines.y > 0) ? MARGIN : 0;
    if (__WSJ__) {
      margin = (options.size === 'print-wsj') ? 0 : margin;
    }
    return {
      innerEl: createInnerEl(highchart, options),
      x: highchart.spacing[3],
      y: info.headlines.y + margin,
      width: options.width - highchart.spacing[1] - highchart.spacing[3],
      height: (info.notes.y - info.headlines.y) - margin,
      spacing: [info.annotations.yTop, 0, info.annotations.yBot, 0],
      info,
    };
  }
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    const updateH = headlines.renderInvalidated(rendered, options, invalidated);
    const updateN = notes.renderInvalidated(rendered, options, invalidated);
    let margin = (rendered.outerInfo.info &&
      rendered.outerInfo.info.headlines.y > 0) ? MARGIN : 0;
    if (__WSJ__) {
      margin = (options.size === 'print-wsj') ? 0 : margin;
    }
    if (updateH) {
      rendered.outerInfo.y += margin;
    }
    if (updateH || updateN) {
      rendered.outerInfo.height = 0;
      if (rendered.outerInfo.info) {
        rendered.outerInfo.height = rendered.outerInfo.info.notes.y -
          rendered.outerInfo.info.headlines.y - margin;
      }
    }
  }
}



function getTopHeight(highchart, options) {
  const svg = options.el.querySelector('svg');
  const svgY = svg.getBoundingClientRect().top;
  if (highchart.subtitle) {
    const srect = highchart.subtitle.element.getBoundingClientRect();
    return srect.top - svgY + srect.height;
  } else if (highchart.title) {
    const trect = highchart.title.element.getBoundingClientRect();
    return trect.top - svgY + trect.height;
  }
  return highchart.spacing[0];
}

function getBottomHeight(highchart, options) {
  return highchart.spacing[2];
}

// Cleans up the outer SVG, removing unnecessary `g` elements, and creates a
// `g` element specifically for the inner chart SVG.
function createInnerEl(highchart, options) {
  const svg = options.el.querySelector('svg');
  if (svg) {
    const gEls = svg.querySelectorAll('g');
    for (let i = 0; i < gEls.length; i++) {
      element.removeChild(gEls[i]);
    }
    return highchart.renderer.g('djchart').add().element;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/chart/outer/index.js